var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "faepca" },
    [
      _c(
        "el-row",
        { staticStyle: { margin: "10px 0 10px 0" } },
        [
          _c("el-col", { attrs: { span: 10 } }, [
            _c("h1", [_vm._v("Gestion des FAE - PCA")])
          ]),
          _vm._v(" "),
          _c(
            "el-col",
            { staticStyle: { "text-align": "right" }, attrs: { span: 14 } },
            [
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    size: "mini",
                    icon: "el-icon-view"
                  },
                  on: { click: _vm.validateForm }
                },
                [_vm._v("Rechercher")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                { attrs: { size: "mini" }, on: { click: _vm.resetForm } },
                [_vm._v("Reset")]
              ),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    icon: "el-icon-d-arrow-right",
                    type: "primary",
                    size: "mini",
                    loading: _vm.btnExportLoading.excel,
                    disabled: !(_vm.rptData && _vm.rptData.length > 0)
                  },
                  on: {
                    click: function($event) {
                      return _vm.handleExport("excel")
                    }
                  }
                },
                [_vm._v("\n          Export Excel\n        ")]
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-form",
        {
          key: "Form_" + _vm.refresh,
          ref: "ElForm",
          attrs: {
            model: _vm.formData,
            rules: _vm.rules,
            "label-width": "250px",
            size: "mini"
          }
        },
        [
          _c(
            "el-row",
            { staticStyle: { margin: "10px 0 10px 0" } },
            [
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Secteur d'activité :",
                        prop: "secteursact"
                      }
                    },
                    [
                      _c("listSecteurActMultiple", {
                        attrs: { data: _vm.secteursact },
                        on: {
                          "update:data": function($event) {
                            _vm.secteursact = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Client :", prop: "clients" } },
                    [
                      _c("listClientMultiple", {
                        attrs: { data: _vm.clients },
                        on: {
                          "update:data": [
                            function($event) {
                              _vm.clients = $event
                            },
                            function($event) {
                              _vm.enseignes = []
                              _vm.refreshEnseigne++
                            }
                          ]
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Enseigne :", prop: "enseignes" } },
                    [
                      _c("listEnseigneMultiple", {
                        key: "Enseigne_" + _vm.refreshEnseigne,
                        attrs: { data: _vm.enseignes, idsClients: _vm.clients },
                        on: {
                          "update:data": function($event) {
                            _vm.enseignes = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Secteur géographique :",
                        prop: "secteursgeo"
                      }
                    },
                    [
                      _c("listSecteurGeoMultiple", {
                        attrs: { data: _vm.secteursgeo },
                        on: {
                          "update:data": function($event) {
                            _vm.secteursgeo = $event
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "el-col",
                { attrs: { span: 12 } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "Conducteur :", prop: "conducteur" } },
                    [
                      _c("listCascaderUtilisateur", {
                        attrs: {
                          idUserSelected: _vm.conducteur,
                          idSociete: _vm.user.id_societe,
                          user: _vm.conducteur,
                          clearable: true
                        },
                        on: {
                          "update:idUserSelected": function($event) {
                            _vm.conducteur = $event
                          },
                          "update:id-user-selected": function($event) {
                            _vm.conducteur = $event
                          },
                          "update:user": function($event) {
                            _vm.conducteur = $event
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    { attrs: { label: "Classement :", prop: "status" } },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: "Sélection",
                            size: "mini",
                            multiple: "",
                            clearable: "",
                            filtreable: ""
                          },
                          model: {
                            value: _vm.status,
                            callback: function($$v) {
                              _vm.status = $$v
                            },
                            expression: "status"
                          }
                        },
                        _vm._l(_vm.options, function(item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: { label: item.label, value: item.value }
                          })
                        }),
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-form-item",
                    {
                      attrs: {
                        label: "Gestion mensuelle de :",
                        prop: "currentDate"
                      }
                    },
                    [
                      _c("el-date-picker", {
                        staticStyle: { width: "200px" },
                        attrs: {
                          format: "MM/yyyy",
                          "value-format": "yyyyMM",
                          size: "mini",
                          type: "month",
                          placeholder: "MM/AAAA"
                        },
                        model: {
                          value: _vm.currentDate,
                          callback: function($$v) {
                            _vm.currentDate = $$v
                          },
                          expression: "currentDate"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      [
        _vm.show
          ? _c(
              "el-table",
              {
                staticStyle: { width: "100%" },
                attrs: {
                  data: _vm.rptData,
                  "summary-method": _vm.getSummaries,
                  size: "mini",
                  "show-summary": "",
                  height: "calc(100vh - 370px)"
                }
              },
              [
                _c(
                  "el-table-column",
                  {
                    attrs: { label: "Gestion des FAE et PCA", align: "center" }
                  },
                  [
                    _c(
                      "el-table-column",
                      [
                        _c("el-table-column", {
                          attrs: {
                            prop: "num_affaire",
                            label: "Code affaire",
                            width: "250"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _c(
                                      "router-link",
                                      {
                                        attrs: {
                                          to: "/affaire/" + scope.row.id
                                        }
                                      },
                                      [
                                        _c(
                                          "el-link",
                                          { attrs: { type: "primary" } },
                                          [
                                            _vm._v(
                                              _vm._s(scope.row.num_affaire)
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1328853995
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "libelle_enseigne",
                            label: "Enseigne",
                            width: "300"
                          }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: { prop: "nom", label: "Affaire", width: "300" }
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mt_PM_mens",
                            label: "PM mensuel",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          _vm._f("toSumMt")(
                                            scope.row.mtPmPrixDeVente -
                                              scope.row.mtPmPrixDeVenteMmoins1,
                                            "mt_PM_mens",
                                            _vm.sums
                                          )
                                        )
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2346484198
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mt_PM_cumule",
                            label: "PM cumulé",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          _vm._f("toSumMt")(
                                            scope.row.mtPmPrixDeVente,
                                            "mt_PM_cumule",
                                            _vm.sums
                                          )
                                        )
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            2980877705
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mt_Fact_mens",
                            label: "Facturé mensuel",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          _vm._f("toSumMt")(
                                            scope.row.mtFacturationClient -
                                              scope.row
                                                .mtFacturationClientMmoins1,
                                            "mt_Fact_mens",
                                            _vm.sums
                                          )
                                        )
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1201625227
                          )
                        }),
                        _vm._v(" "),
                        _c("el-table-column", {
                          attrs: {
                            prop: "mt_Fact_cumule",
                            label: "Facturé cumulé",
                            width: "120",
                            align: "right"
                          },
                          scopedSlots: _vm._u(
                            [
                              {
                                key: "default",
                                fn: function(scope) {
                                  return [
                                    _vm._v(
                                      _vm._s(
                                        _vm._f("toCurrency")(
                                          _vm._f("toSumMt")(
                                            scope.row.mtCumulFacturationClientM,
                                            "mt_Fact_cumule",
                                            _vm.sums
                                          )
                                        )
                                      )
                                    )
                                  ]
                                }
                              }
                            ],
                            null,
                            false,
                            1706562363
                          )
                        }),
                        _vm._v(" "),
                        _c(
                          "el-table-column",
                          { attrs: { label: "Cumulé", align: "center" } },
                          [
                            _c("el-table-column", {
                              attrs: {
                                prop: "mt_PCA_cumule",
                                label: "PCA",
                                width: "120",
                                align: "right"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("toCurrency")(
                                                _vm._f("toSumMt")(
                                                  Number(
                                                    scope.row
                                                      .mtCumulFacturationClientM
                                                  ) >
                                                    Number(
                                                      scope.row.mtPmPrixDeVente
                                                    )
                                                    ? scope.row
                                                        .mtCumulFacturationClientM -
                                                        scope.row
                                                          .mtPmPrixDeVente
                                                    : "",
                                                  "mt_PCA_cumule",
                                                  _vm.sums
                                                )
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                2357248394
                              )
                            }),
                            _vm._v(" "),
                            _c("el-table-column", {
                              attrs: {
                                prop: "mt_FAE_cumule",
                                label: "FAE",
                                width: "120",
                                align: "right"
                              },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(scope) {
                                      return [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              _vm._f("toCurrency")(
                                                _vm._f("toSumMt")(
                                                  Number(
                                                    scope.row.mtPmPrixDeVente
                                                  ) >
                                                    Number(
                                                      scope.row
                                                        .mtCumulFacturationClientM
                                                    )
                                                    ? scope.row
                                                        .mtPmPrixDeVente -
                                                        scope.row
                                                          .mtCumulFacturationClientM
                                                    : "",
                                                  "mt_FAE_cumule",
                                                  _vm.sums
                                                )
                                              )
                                            ) +
                                            "\n              "
                                        )
                                      ]
                                    }
                                  }
                                ],
                                null,
                                false,
                                4052097178
                              )
                            })
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _vm._e()
      ]
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }